import clsx from "clsx";
import styled from "styled-components";

import { Text } from "~/components/Text";
import * as Bulma from "~/types/bulma";

export type ContainerProps = { mode?: "boxed" | "toggle" | "toggle-rounded" | null } & Bulma.Alignment &
  Bulma.Sized &
  Bulma.Expandable;

/**
 * @example
 *
 * import Tabs from "~/components/Tabs";
 *
 * <Tabs.Container>
 *   <Tabs.Content>
 *     <Tabs.Item>
 *       <a>Pictures</a>
 *     </Tabs.Item>
 *     <Tabs.Item active>
 *       <a>Music</a>
 *     </Tabs.Item>
 *   </Tabs.Content>
 * </Tabs.Container>
 */
export const Container = styled.nav.attrs<ContainerProps>((props) => ({
  className: clsx({
    [`tabs`]: true,
    [`is-fullwidth`]: props.fullwidth,
    [`is-${props.align}`]: Boolean(props.align),
    [`is-${props.mode}`]: Boolean(props.mode),
    [`is-${props.sized}`]: Boolean(props.sized),
  }),
  [`role`]: `navigation`,
}))<ContainerProps>``;

export const Content = styled(Text).attrs({
  as: "ul",
})``;
Content.defaultProps = {
  weight: "bolder",
  transform: "uppercase",
};

export const Item = styled.li.attrs<Bulma.Activable>((props) => ({
  className: clsx({
    [`is-active`]: props.active,
  }),
}))<Bulma.Activable>`
  a {
    border-bottom-width: ${(props) => (props.active ? "6px" : "6px" /* 1px is weird */)};
    border-bottom-color: ${(props) => (props.active ? props.theme.colors.black : "transparent")};
  }
`;
